const OrderTimeEnum = {
  NOW      : 'now',
  SCHEDULED: 'scheduled'
}

export default OrderTimeEnum
